module.exports = __webpack_public_path__ + "img/Spotify.f0c9e3f4.svg";